import axios from "axios";
import { BASE_URL } from "./api";

export async function getClientTransactions(token, queryParams){
    return axios({
        method: 'get',
        url: `${BASE_URL}/client_transactions${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response;
    }).catch((error) => {
        return error
    });
}


export async function updateClientTransaction(token, transactionId, data) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/client_transactions/${transactionId}/update_client_transaction/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        // console.log(response)
        return response
    }).catch((error) => {
        console.log(error)
        return error
    });
  }